module.exports = __webpack_public_path__ + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Regular.woff?6ffaa042b52de9fdbb29262b774756c5]";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Regular.woff
// module id = 1889
// module chunks = 32